import { Provider } from '@angular/core';
import {
  GetMonthlyShiftsUseCase,
  UpdateMonthlyShiftsUseCase,
  UpdateTeamNamesUseCase,
} from '@app/application/use-cases/schedule';
import { ScheduleRepository } from '@app/domain/repositories/schedule.repository';
import { ScheduleRepositoryImpl } from '../repositories/schedule.repository.impl';

export const SCHEDULE_PROVIDERS: Provider[] = [
  {
    provide: ScheduleRepository,
    useClass: ScheduleRepositoryImpl,
  },
  {
    provide: GetMonthlyShiftsUseCase,
    useFactory: (scheduleRepo: ScheduleRepository) =>
      new GetMonthlyShiftsUseCase(scheduleRepo),
    deps: [ScheduleRepository],
  },
  {
    provide: UpdateMonthlyShiftsUseCase,
    useFactory: (scheduleRepo: ScheduleRepository) =>
      new UpdateMonthlyShiftsUseCase(scheduleRepo),
    deps: [ScheduleRepository],
  },
  {
    provide: UpdateTeamNamesUseCase,
    useFactory: (scheduleRepo: ScheduleRepository) =>
      new UpdateTeamNamesUseCase(scheduleRepo),
    deps: [ScheduleRepository],
  },
];
